import { privateApi, publicApi } from './index';

export const getGuide = (code : any) =>
  publicApi.get('/shipments/' + code);

export const saveGuide = (data : any) =>
  privateApi.post('/shipments/register', data);

export const getCurrents = () =>
  privateApi.get('/shipments-current');

export const setStatus = (data : any) => 
  privateApi.post('/shipments/status', data);

export const getShipments = () =>
  privateApi.get('/shipments');

export const getStats = () =>
  privateApi.get('/shipments-stats');
